import type { FC } from 'react';

import { cn } from '@/shared/libs';

export interface CountryFlagProps {
  className?: string;
  code: string;
}

const toFlagCode = (value: string): string => {
  const code = value.trim().toLowerCase();
  const iso = code === 'uk' ? 'gb' : code;

  return /^[a-z]{2}$/.test(iso) ? iso : '';
};

export const CountryFlag: FC<CountryFlagProps> = ({ className, code }) => {
  const iso = toFlagCode(code);

  if (!iso) {
    return null;
  }

  return (
    <span
      aria-hidden
      className={cn(
        'fi shrink-0 rounded-[2px] text-sm leading-none',
        `fi-${iso}`,
        className,
      )}
    />
  );
};

CountryFlag.displayName = 'CountryFlag';
